import { Button } from '@heroui/react';
import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';

import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      isIconOnly
      variant="light"
      onPress={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      className={`hover:bg-default-100 transition-all border border-transparent hover:border-default-200 text-default-700 hover:text-foreground ${
        className || ''
      }`}
      size="lg"
    >
      {theme === 'light' ? (
        <FiMoon size={20} className="text-default-700" />
      ) : (
        <FiSun size={20} className="text-default-400" />
      )}
    </Button>
  );
};
